export default {
  CLASSIFIED: 'C',
  AUCTION: 'A',
  TRADING_PERIOD: 'T',
  WANTED: 'W'
}
